"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ButtonGroup_1 = require("./ButtonGroup");
exports.default = ButtonGroup_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ButtonGroup/index.js
// module id = 1745
// module chunks = 8